import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { LabCorpEdifecsStandardCompendium } from '../../models/lab-corp-edifecs-standard-compendium';
import {
    shouldUpdateState,
    storeData
} from '../../utils/converter';
import { getLabCorpEdifecsStandardCompendiums } from '../../apis/emr-data';

export interface State {
    byId: Dictionary<LabCorpEdifecsStandardCompendium>;
    loading: Dictionary<boolean>;
}

export const labCorpEdifecsStandardCompendiums = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: LabCorpEdifecsStandardCompendium[],
            loadingKey?: string
        ): State => {
            if (shouldUpdateState(data, loadingKey)) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeData(data, 'orderCode')
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getLabCorpEdifecsStandardCompendiumsAsync(
            ids: Undefinable<string>[],
            rootState: RootState
        ) {
            const notExistedIds = selectors.getOtherLabCorpEdifecsStandardCompendiumIds(rootState.labCorpEdifecsStandardCompendiums, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getLabCorpEdifecsStandardCompendiums(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
